import { Component, EventEmitter, HostListener, Input, OnInit } from '@angular/core';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-copy-fade-button',
  templateUrl: './copy-fade-button.component.html',
  styleUrls: ['./copy-fade-button.component.scss'],
  animations: [
    trigger('stateChanged', [
      state('primary', style({ 
        color: '#0073d0',
        background: '#ffffff',
        height: '48px'
      })),
      state('secondary', style({ 
        color: '#ffffff',
        background: '#3fac49',
        height: '48px'
      })),
      transition('*=>secondary', animate('0ms')),
      transition('secondary=>primary',  animate('2000ms', style({opacity: 0}))),
    ])
  ]
})

export class CopyFadeButtonComponent implements OnInit {
  @Input() stringToCopy: string;
  @Input() useAsId: string;

  state: string = 'primary';
  theButtonLabel: string;
  primaryStr: string;
  secondaryStr: string;
  buttonElement: any;

  constructor( private translateService: TranslateService ) 
  {

  }

  ngOnInit(): void 
  {
    this.primaryStr =  this.translateService.instant('integrations.copy');
    this.secondaryStr =  this.translateService.instant('integrations.copied');
    this.theButtonLabel = this.primaryStr;
  }

  onButtonClicked(event)
  {
    console.log("The button was invoked", event);
    if ( this.state == 'primary' )
    {
      
      this.state = 'secondary';
      this.theButtonLabel = this.secondaryStr;
      setTimeout( ()=> {
        this.onButtonClicked(event);
      });
    }
    else{
      this.state = 'primary';
      setTimeout( () => {
        this.theButtonLabel = this.primaryStr;
      }, 2000);
    }
  }

  copiedToClipboard(event)
  {
    console.log("The value has been copied to the clipboard", event);
    if ( this.buttonElement )
    {
      console.log("Existing button element", this.buttonElement);
      this.buttonElement.focus();
    }
    else
    {
      console.log("request the button element", this.useAsId);
      this.buttonElement = document.getElementById(this.useAsId);
      console.log("got the button element", this.buttonElement);
      this.buttonElement.focus();
    }
  }
}
